import "./src/styles/global.css";
import React from "react"; // required: Gatsby Babel uses classic JSX transform
import MainLayout from "./src/layout/MainLayout";

export const wrapPageElement = ({ element }) => (
    <MainLayout>
        <div id="page-content">{element}</div>
    </MainLayout>
);
